import React from "react";
import { CommentReference, UserToken } from "../../amorg-common";
import { ProtectedPageContext } from "../../pages/_contexts/ProtectedPageContext";
import { Drawer } from "../Drawer";
import { CommentPanel } from "./CommentPanel";
import { getComments } from "../../api/commentClientApi";
import { Flex } from "./FlexHelpers";
import { Button } from "../button/Button";

export function CommentDrawer(props:{ 
    readOnly?: boolean,
    visible: boolean, 
    reference:CommentReference,
    onClose: () => void, 
    onCommentsLoaded?:(commentCount:number)=>void })
{
    const ctx = React.useContext(ProtectedPageContext);

    return (
        <Drawer visible={props.visible} onClose={props.onClose}>
            <CommentPanel 
                readOnly={props.readOnly}
                activeUser={ctx.user as UserToken}
                commentReference={props.reference}
                onGetCommentCount={(count) => props.onCommentsLoaded?.(count)} 
            />
        </Drawer>
    );
}

export function CommentDrawerButton(props: {
    reference: CommentReference,
}) {
    const [showDrawer, setShowDrawer] = React.useState<boolean>(false);
    const [commentCount, setCommentCount] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        const getData = async () => {
            const count = (await getComments(props.reference.type, props.reference.id)).length;
            setCommentCount(count);
        };
        getData();
    }, [props.reference]);

    function handleGetCommentsCount(count: number) {
        setCommentCount(count);
    }

    async function handleCloseModal() {
        setShowDrawer(false);
    }


    return (
        <>
            <Flex gap={4} alignItems="center">
                <Button 
                    variant="text" 
                    icon="comment"
                    size="32px"
                    text={commentCount === undefined 
                        ? `Kommentarer` 
                        : `Kommentarer (${commentCount})`
                    }
                    onClick={() => setShowDrawer(true)} />
            </Flex>

            <CommentDrawer
                visible={showDrawer}
                reference={props.reference}
                onCommentsLoaded={handleGetCommentsCount}
                onClose={handleCloseModal}
            />
        </>
    );
}
